/* eslint-disable */
import React from "react";
import InputMask from 'react-input-mask';
import TextField from "@mui/material/TextField";
// localizations
import { withTranslation } from "react-i18next";
const InputMaskField = (props) => {
  const { InputProps, inputProps, sx, type, label, autoFocus, className, variant, id, name, value, onChange, mask, autoComplete, error, helperText } = props

  return (
    <InputMask 
      maskChar={null} 
      mask={mask} 
      value={value} 
      onChange={onChange}
      onPaste={(e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }}
    >
      {(maskProps) => <TextField 
        {...maskProps}
        {...inputProps}
        type={type} 
        sx={sx} 
        id={id} 
        autoFocus={autoFocus} 
        name={name} 
        variant={variant} 
        className={className} 
        label={label} 
        InputProps={InputProps}  
        autoCorrect="off"
        spellCheck={false}
        data-lpignore="true"
        data-1p-ignore="true"
        data-bwignore="true"
        data-dashlane-ignore="true"
        data-bitwarden-ignore="true"
        data-form-type="other"
        autoComplete="new-password"
        style={{
          WebkitUserSelect: 'none',
          userSelect: 'none'
        }}
        error={error}
        helperText={helperText}
      />}
    </InputMask>
  )
}
  export default withTranslation()(InputMaskField);